/** @format */

import styled from 'styled-components';

export const Dropdown = styled.div<{ $isPageListing?: boolean }>`
  position: relative;

  ${({ $isPageListing }) =>
    $isPageListing &&
    `
    @media screen and (max-width: 920px) {
      position: initial;
    }
    @media screen and (max-width: 650px) {
      position: relative;
    }
  `}
`;

export const DropdownTrigger = styled.div<{ $isPageListing?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: ${({ $isPageListing }) => ($isPageListing ? '0' : 'clamp(1rem, 0.6203rem + 1.6878vw, 1.5rem)')};

  button {
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    display: flex;
  }
`;

export const DropdownContent = styled.div<{ $isPageListing?: boolean }>`
  position: absolute;
  top: 100%;
  width: 40.25rem;

  ${({ $isPageListing }) =>
    $isPageListing
      ? `
    @media screen and (max-width: 920px) {
      left: 50%;
      transform: translate(-50%, -1rem);

    }
  `
      : `
    @media screen and (max-width: 833px) {
      width: 100%;
    }`}

  display: grid;
  grid-template-columns: repeat(3, 1fr);

  gap: 3rem;

  margin-top: 0.5rem;
  padding: 1.5rem;
  border: 1px solid #eaecf0;
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.colors.joivy.white};
  color: var(--gray-600, #475467);
  box-shadow: 0px 24px 48px -12px rgba(16, 24, 40, 0.18);

  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.75rem;
  text-align: start;

  scroll-margin: 1rem;

  opacity: 0;
  visibility: hidden;
  z-index: -1;
  transition: all 0.4s cubic-bezier(0.36, 0.33, 0, 1);

  &[data-open='true'] {
    opacity: 1;
    visibility: visible;
    z-index: 2;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  @media screen and (max-width: 650px) {
    display: none !important;
  }
`;

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.125rem;
  background: ${({ theme }) => theme.colors.joivy.yellow};

  span {
    color: ${({ theme }) => theme.colors.joivy['teal-dark']};

    font-size: 1.125rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.75rem;

    @media screen and (max-width: 833px) {
      display: none;
    }
  }
`;

export const CountriesList = styled.ul`
  display: grid;
  gap: 0.25rem;
  align-self: start;

  @media screen and (max-width: 650px) {
    display: flex;
    align-items: center;
    gap: 1rem;
    border-bottom: 0.0625rem solid #d9d9d9;

    img {
      display: none;
    }
  }
`;

export const CountryItem = styled.li<{ $active: boolean }>`
  display: grid;
  align-items: stretch;

  button {
    cursor: pointer;
    border: none;
    background: none;
    border-radius: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0.5rem 1.31rem;
    padding-left: 1rem;

    border-left: 5px solid transparent;

    color: ${({ $active, theme }) => ($active ? theme.colors.joivy['teal-dark'] : 'var(--gray-600, #475467);')};
    font-size: 1.125rem;
    font-weight: ${({ $active }) => ($active ? 700 : 500)};
    line-height: 1.75rem;

    .number {
      color: ${({ $active, theme }) => ($active ? theme.colors.joivy['teal-dark'] : 'var(--gray-500, #667085)')};
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.25rem;

      @media screen and (max-width: 650px) {
        color: var(--gray-600, #475467);
      }
    }

    transition: background 0.3s ease-in-out;

    &:hover {
      background: #fcfcfd;
    }

    ${({ $active, theme }) => {
      const activeStyles = `
          border-left: 5px solid ${theme.colors.joivy['teal-dark']};
          background: #FCFCFD;
          `;

      if ($active) return activeStyles;
    }}

    @media screen and (max-width: 650px) {
      color: #344054;
      text-align: center;
      font-size: 1rem;
      font-weight: ${({ $active }) => ($active ? 600 : 400)};
      line-height: 1.5;
      border: none;

      background: none;

      width: fit-content;
      padding: 0.5rem;
      padding-bottom: 0;

      &:hover {
        background: none;
      }

      span:not(.number) {
        display: block;
        padding-bottom: 0.5rem;
        border-bottom: 0.125rem solid
          ${({ $active, theme }) => ($active ? theme.colors.joivy['teal-dark'] : 'transparent')};
      }

      &:first-of-type {
        padding-left: 0;
      }
    }
  }
`;

export const CitiesList = styled.ul<{ $rows?: number }>`
  display: grid;
  grid-column: 2 / -1;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: ${({ $rows }) => `repeat(${$rows}, 1fr)`};
  column-gap: 1.5rem;

  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    gap: 0.25rem;
  }
`;

export const CityItem = styled.li`
  a {
    width: 100%;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.5ch;
    color: #101828;
    font-size: 1rem;
    line-height: 1.5;
    padding: 0.5rem;
    font-weight: 400;

    transition: all 0.3s ease-in-out;

    &:hover {
      background: #f9fafb;
    }

    @media screen and (max-width: 650px) {
      padding: 0.5rem 0;
      color: #101828;
    }

    .hot {
      color: ${({ theme }) => theme.colors.joivy.pink};
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.25rem;
    }
  }
`;

export const Overlay = styled.div`
  @media screen and (min-width: 651px) {
    display: none;
  }

  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 5;
`;

export const DropdownContentMobile = styled.div<{ $open?: boolean }>`
  ul {
    padding: 0;
    list-style: none;
  }

  @media screen and (min-width: 651px) {
    display: none;
  }

  --content-padding-inline: 1rem;
  --content-padding-block: 1.81rem;
  --border-radius: 1rem;
  --animation: ${({ $open }) => ($open ? 'fade-in' : 'fade-out')};

  width: 100%;
  background-color: ${({ theme }) => theme.colors.joivy.white};
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 4;
  overflow-y: scroll;
  overflow-x: hidden;
  animation: var(--animation) 0.4s cubic-bezier(0.36, 0.33, 0, 1);
  height: 71.5vh;
  height: 71.5dvh;
  isolation: isolate;

  border-radius: var(--border-radius) var(--border-radius) 0 0;

  padding-inline: var(--content-padding-inline);

  @keyframes fade-in {
    0% {
      transform: translateY(100%);
    }

    100% {
      transform: translateY(0);
    }
  }

  @keyframes fade-out {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(100%);
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const MobileSticky = styled.div`
  @media screen and (max-width: 650px) {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
    background: ${({ theme }) => theme.colors.joivy.white};
  }

  padding-top: var(--content-padding-block);
`;

export const MobileHeader = styled.div`
  @media screen and (min-width: 651px) {
    display: none;
  }

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #101828;
  text-align: center;

  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.5;

  p {
    margin: 0;
  }

  button {
    position: absolute;
    right: 0;
    border: none;
    border-radius: 50%;
    width: 24px;
    aspect-ratio: 1;
    display: grid;
    place-content: center;
  }
`;

export const SelectedCityItem = styled.span`
  color: ${({ theme }) => theme.colors.joivy.yellow};
`;

export const SelectButton = styled.button<{ $isPageListing?: boolean }>`
  flex-grow: 1;
  padding: ${({ $isPageListing }) => ($isPageListing ? 0 : '1rem 1.5rem')};
  background: ${({ $isPageListing, theme }) => ($isPageListing ? 'transparent' : theme.colors.joivy.white)};
  color: ${({ $isPageListing, theme }) => ($isPageListing ? theme.colors.joivy.white : theme.colors.darkGrey)};
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.75rem;
  align-items: flex-start;
  justify-content: space-between;
  --rotation: 0deg;
  column-gap: ${({ $isPageListing }) => ($isPageListing ? 0.5 : 0)}rem;

  img {
    transition: transform 0.3s ease-in-out;
    transform: rotate(var(--rotation));
  }

  &[data-open='true'] {
    --rotation: 180deg;
  }

  .destination {
    @media screen and (max-width: 480px) {
      display: none;
    }
  }

  &:has(.destination) ${SelectedCityItem} {
    @media screen and (max-width: 480px) {
      max-width: 10.5rem;
      text-overflow: ellipsis;
      text-wrap: nowrap;
      overflow: hidden;
    }
  }
`;
